import {NextSeo} from "next-seo";
import {Header} from "@/components/Header";
import HeaderSimple from "@/components/HeaderSimple";
import {CallToAction} from "@/components/CallToAction";
import {Footer} from "@/components/Footer";
import tutoringGroupImage from '@/images/tutoring-group.jpg'

export default function TipsBijlesOrganiseren() {
    return (
        <>
            <NextSeo
                title="5 tips om je bijles op school goed (en goedkoop) te organiseren"
                description="Wil je bijles op school organiseren die voor iedereen toegankelijk is en echt helpt? Ontdek onze 5 tips voor een kwalitatieve en betaalbare aanpak."
            />
            <Header/>
            <main>
                <HeaderSimple
                    image={tutoringGroupImage}
                    title="5 tips om je bijles op school goed (en goedkoop) te organiseren"
                    text={
                        <span>
                            Er wordt veel gezegd en geschreven over bijles. Het vergroot de onderwijskloof en werkt kansenongelijkheid in de hand. Er zijn tal van commerciële bureaus die liever geld verdienen dan leerlingen te helpen bij de leerstof.
                    <br/><br/>
Genoeg reden dus om te kijken hoe het anders kan, zodat bijles wel voor iedereen toegankelijk is én op een kwalitatief hoogwaardig manier gegeven wordt. Zodat het leerlingen écht helpt. Bijlesplein heeft hiervoor 5 tips om de bijles binnen jouw school eerlijk en goed te laten slagen:
                        </span>
                    }
                />


                <div className="mx-auto max-w-3xl text-base leading-7 text-gray-700 px-4">

                    <div className="mt-10 max-w-2xl">
                        <h2 className="text-2xl font-bold tracking-tight text-gray-900">
                            1. Stimuleer bijles tussen leerlingen onderling, tutoring werkt beter
                        </h2>
                        <p className="mt-6">
                            Het leren van en met medeleerlingen is bewezen effectief. Het is bewezen dat tutoring door
                            leerlingen een positief effect heeft op de leerprestaties. Gemiddeld zelfs ongeveer vijf
                            maanden extra leerwinst in een schooljaar (bron: Onderwijskennis.nl). Onderzoek laat zien
                            dat zowel de leerling die als tutor optreedt als de tutee hier profijt van kan hebben.
                            Hoewel alle typen leerlingen voordeel kan hebben van tutoring door leerlingen, is er enig
                            bewijs dat minder goed presterende leerlingen en leerlingen met specifieke
                            onderwijsbehoeften er het meest aan hebben.
                        </p>

                        <p className="font-semibold mt-8 text-gray-900">Gelijke kansen bevorderen</p>
                        <p className="">
                            Minder goed presterende leerlingen profiteren extra van tutoring door medeleerlingen. Deze
                            aanpak kan leerlingen helpen leerachterstanden weg te werken door onder gerichte begeleiding
                            van een medeleerling behandelde stof te verankeren, vaardigheden te oefenen, en
                            misverstanden vast te stellen en weg te nemen.
                        </p>
                        <p className="mt-2">
                            Omdat tutoring een goedkope (of zelfs gratis) vorm van bijles is, is het voor nagenoeg
                            iedereen toegankelijk. Daarmee komen we op de volgende voorwaarde.
                        </p>

                        <h2 className="text-2xl font-bold tracking-tight text-gray-900 mt-8">
                            2. Ga kansenongelijkheid tegen en biedt bijles gratis of heel laagdrempelig aan
                        </h2>
                        <p className="mt-6">
                            Kansenongelijkheid in het onderwijs is dat leerlingen of studenten met dezelfde talenten
                            niet dezelfde kansen krijgen. Dat heeft meerdere oorzaken. Één van die oorzaken is de
                            (beperkte) mogelijkheden van ouders. Het hangt bijvoorbeeld af van hun onderwijsniveau, het
                            netwerk en de steun die zij krijgen van vrienden en familie. Maar ook welke (financiële)
                            mogelijkheden hebben zij om te helpen bij schoolwerk.
                        </p>

                        <p className="mt-8">
                            De kloof tussen leerlingen die bijles wel of niet kunnen betalen kun je wegnemen door bijles
                            (nagenoeg) gratis aan te bieden. Dat kan door leerlingen elkaar bijles te laten geven.
                            Iedereen heeft gelijke rechten op bijles. Niet elke ouder kan een commerciële
                            bijlesaanbieder betalen.
                        </p>

                        <h2 className="text-2xl font-bold tracking-tight text-gray-900 mt-8">
                            3. Zorg ervoor dat bijlesgevers/tutors handvatten hebben om goede bijles te geven, het zijn
                            de leraren van de toekomst
                        </h2>
                        <p className="mt-6">
                            Leerlingen die bijles geven, doen waardevolle ervaring op. Zij zijn de leraren van de
                            toekomst. Motiveer leerlingen daarom om het te doen. Sommige zullen een drempel ervaren,
                            help ze daar overheen en geef ze tips en het vertrouwen.
                        </p>

                        <p className="mt-8">
                            Het draagt bij aan de kwaliteit van de bijles én het motiveert leerlingen hun bijles goed te
                            geven waardoor ze wellicht enthousiast worden over het lerarenvak. Twee vliegen in één klap.
                        </p>

                        <h2 className="text-2xl font-bold tracking-tight text-gray-900 mt-8">
                            4. Zorg ervoor dat leerlingen elkaar eenvoudig weten te vinden
                        </h2>
                        <p className="mt-6">
                            Als onderwijsinstelling kun je met Bijlesplein heel eenvoudig stimuleren dat leerlingen
                            elkaar helpen door vraag en aanbod voor bijles bij elkaar te brengen. Dat scheelt je ook nog
                            eens heel veel administratielast zoals het bijhouden van Excellijsten en het koppelen van
                            leerlingen. Die tijd kan worden besteed aan de kwaliteit van het onderwijs en het
                            faciliteren van tutors.
                        </p>

                        <h2 className="text-2xl font-bold tracking-tight text-gray-900 mt-8">
                            5. Burgerschap bevorderen
                        </h2>
                        <p className="mt-6">
                            Naast het bijbrengen van kennis moeten scholen leerlingen helpen bij het opdoen van
                            ervaringen met betrekking tot de diverse en democratische samenleving. De school wordt
                            gezien als een soort oefenplaats, een samenleving in het klein. Op school ervaren leerlingen
                            wat het betekent om onderdeel te zijn van een groter geheel, vol verschillende mensen. Er
                            zijn meerdere manieren om hieraan bij te dragen en het geven van bijles aan andere
                            leerlingen is zo’n manier om te leren over burgerschap.
                        </p>

                        <p className="mt-8">
                            Faciliteer daarom tutoring: niet alleen omdat het beter werkt, ook omdat het burgerschap
                            bevordert. Door leerlingen in de rol van tutor te plaatsen, ontwikkelen zij
                            verantwoordelijkheidsgevoel, empathie en sociale vaardigheden. Dit helpt niet alleen de
                            tutoren zelf, maar versterkt ook de onderlinge betrokkenheid en solidariteit binnen de
                            schoolgemeenschap. Leerlingen leren anderen kennen uit een andere omgeving dan waar ze zelf
                            of hun vrienden zich bevinden.
                        </p>

                    </div>

                    <p className="mt-8">
                        De conclusie uit bovenstaande om bijles beter te organiseren komt er vooral op neer dat je als
                        school het geven van bijles tussen leerlingen onderling, tutoring, moet bevorderen en
                        faciliteren. Dat heeft meerdere voordelen: het werkt beter, gaat kansenongelijkheid tegen,
                        leerlingen doen waardevolle ervaring op, zorgt voor verbinding en het bevordert burgerschap.
                    </p>

                    <p className="mt-8 text-sm opacity-70 mb-8">
                        Ben je nog zoekende hoe dat voor jullie school of scholengemeenschap werkt? Neem contact op met
                        Frits Timmermans, frits@bijlesplein.nl of 0653571911.
                    </p>

                </div>

                <CallToAction/>
            </main>
            <Footer/>
        </>
    )
}
